module.exports = __webpack_public_path__ + "static/media/covid.c92768bd.jpg";